import React, { Component } from "react";
import { connect } from 'react-redux';
import OpenModalButton from 'components/ThemeComponents/openModelButton';
import Confirmalertfordelete from 'components/ThemeComponents/confirmAlertForDelete';
import { confirmAlert } from 'react-confirm-alert';
import { Grid, Row, Col, OverlayTrigger, Popover, Tooltip} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import MDMediaForm from "./MDMediaForm";
import { helperFunctions as HF } from 'helper/helperFunctions';
import ThemeModal from 'components/ThemeComponents/ThemeModal';
import { festivalActions } from 'redux/actions/festival-action';
import FileViewer from 'react-file-viewer';
import { CustomErrorComponent } from 'custom-error';
import Wavesurfer from 'react-wavesurfer';
import play from "assets/img/play.png";
import pause from "assets/img/pause.png";
import ReactPlayer from 'react-player';
import BackNavigationButton from "components/ThemeComponents/BackNavigationButton";
var moment = require("moment");
var Modal = require('react-bootstrap-modal');
var dateFormat = require('dateformat');
var FileSaver = require('file-saver');
window.WaveSurfer = require("wavesurfer.js");
class MDMediaListPage extends Component {
	constructor(props) {
		super(props);
		// const { mdId } = this.props.mdId ? this.props.mdId : this.props.match.params;
		// console.log('mdId sfd', mdId);
		this.state = {
	  		createMDMediaModal  : false,
      		editMDMediaModal : false,
      		editMediaFormType : null,
      		mdId:this.props.mdId ? this.props.mdId : this.props.match.params.mdId,
	      	sorted   : '',
	      	filtered : '',
	      	pageSize : 10,
	      	page 	 : 0,
	      	playing:[],
      		pos:[],
      		durationAudio:[],
	  	};
	  	// console.log('mdId', this.state.mdId);
	  	this.props.getMDMediaCall(this.state.mdId);
	  	// this.agencyMediaPaginationData 	= this.agencyMediaPaginationData.bind(this);
	  	// this.filterSearchHandle     	= this.filterSearchHandle.bind(this);
	  	// this.handleMediaSubmit 			= this.handleMediaSubmit.bind(this);
	  	this.deleteMedia 				= this.deleteMedia.bind(this);
  		this.deleteConfirmMedia 		= this.deleteConfirmMedia.bind(this);
  		this.toggleModal 				= HF.toggleModal.bind(this);
	}
	// agencyMediaPaginationData(page = this.state.page, filtered = this.state.filtered, sorted = this.state.sorted, pageSize = this.state.pageSize){
	//     this.props.getMDMediaPaginationCall(page, filtered, sorted, pageSize);
 //  	}
  	// filterSearchHandle(e){
	  //   this.setState({
	  //   	'filtered': e.target.value
	  //   });
  	// }
  	// handleMediaSubmit(InvData, formType){
  	// 	// const { page, pageSize } = this.state;
  	// 	if (formType === 'create'){
   //  		this.props.storeAgencyMediaCall(InvData).then(
   //  			response =>{
   //  				this.setState({
   //  					createMDMediaModal: false
   //  				}, function(){
   //  					this.agencyMediaPaginationData();
   //  				});
   //  			}
   //  		);
   //  	}
   //  	else if (formType === 'edit'){
   //  		const { editMediaFormType }  = this.state;
   //    		this.props.updateAgencyMediaCall(InvData, this.props.editMDMedia.id, editMediaFormType).then(
   //    			response => {
   //    				this.setState({
   //    					editMDMediaModal: false
   //    				}, function(){
   //    					this.agencyMediaPaginationData();
   //    				});
   //    			}
   //    		);
   //  	}
  	// }
  	deleteMedia(MDId){
    	this.props.deleteMDMediaCall(MDId);
  	}
	deleteConfirmMedia(MDId){
	  	confirmAlert({
	      customUI: ({ onClose }) => {
	        return (
	          <Confirmalertfordelete typeName="Media" description="Are you sure to delete the admin inventory?" onClosePro={ onClose }  deleteType={()=>this.deleteMedia(MDId)} />
	        )
	      }
	    })
	}
	
	componentDidUpdate(prevProps, prevState) {
		if ( prevProps.storeMDMedia !== this.props.storeMDMedia || prevProps.deleteMDMedia !== this.props.deleteMDMedia ) {
			this.props.getMDMediaCall(this.state.mdId);	
		}
	}
	onError(e) {
		console.log(e, 'error in file-viewer');
	}
	handlePosChange(e, num) {
	    const posTemp = {...this.state.pos};
	    posTemp[num] = e.originalArgs[0];
	    this.setState({pos: posTemp});
  	}
  	handleFinish(e, num){
	    const playingTemp = {...this.state.playing};
	    playingTemp[num] = false;
	    this.setState({playing: playingTemp}, function(){
	    	const posTemp = {...this.state.pos};
	      	posTemp[num] = 0;
	      	this.setState({pos: posTemp});
	    });
  	}
  	downloadFile(recUrl, adjudicatorName) {
	    FileSaver.saveAs(recUrl,adjudicatorName);
	}
  	handleLoadingAudio(e, num){
    	const durationTemp = {...this.state.durationAudio};
    	durationTemp[num] = e.wavesurfer.backend.buffer.duration;
    	this.setState({durationAudio:durationTemp});
  	}
  	handleTogglePlay(num) {
	    const playingTempNew = {...this.state.playing};
	   
	    var playingTempNewKeys = Object.keys(playingTempNew);
	    var playingTempNewLen = playingTempNewKeys.length;

	    for(var i = 0 ; i < playingTempNewLen; i++){
	      if (playingTempNew[i] && (i !== num) ){
	        playingTempNew[i] = false;
	      }
	    }

	    this.setState({playing: playingTempNew}, function(){
	      const playingTemp = {...this.state.playing};
	      playingTemp[num] = !playingTemp[num];
	      this.setState({playing: playingTemp});
	    });
  	}
	render() {
		const { mdId, pos, playing, durationAudio } = this.state;
		const { MDMediaList, MDFestival } = this.props;
		return(
			<div className={ "content "+(localStorage.getItem('music-director')?'section-frontEnd ':'') + (localStorage.getItem('admin-user') ? 'AdminSide ':'') }>
		        <Grid fluid>
		        	<Row>
		        		
		            	<Col md={12}>
		            		<div style={{ marginBottom: "10px" }}>
		            			<BackNavigationButton
		            				defaultPath="Festivals"
		            				queryPrefix=""
		            				className="btn btn-info btn-sm"
		            				title="Back"
		            			/>
		            		</div>

		                 	<div className="comments_container">
		                 		<div className="all_comments">
		                 			{  MDFestival && MDFestival['name'] }
	                                <OpenModalButton 
	                                  openModal={HF.openModal.bind(this, "createMDMediaModal")} 
	                                  classButton={['download_all']} 
	                                  buttonName="Add Festival Performance" 
	                                  tooltipText={'Add Festival Performance'}
	                                  classIcon={['fa', 'fa-plus']}
	                                />
		                          	<div className="clearfix"></div>
	                 			</div>

	                          	<div id="mdMedia-list">
	                      			{
	                      				MDMediaList &&
										MDMediaList.map((prop, key) => {
											return (
	                              				<div className="flexElem alignCenter mediaLine flexFullWidth block flexResponsive" key={key}>
	                              					<div>
	                              						<table className="mediaInnerTable">
	                              							<tbody>
	                              								{/*<tr>
	                              									<td className="text-muted">Festival Name:</td>
	                              									<td> { MDFestival['name'] }</td>
	                              								</tr>
	                              								<tr>
	                              									<td className="text-muted">Music Director:</td>
	                              									<td> {prop.music_director.name}</td>
	                              								</tr>*/}
	                              								<tr>
	                              									<td className="text-muted">Uploaded Date:</td>
	                              									<td> { moment( moment.utc(prop.created_at).toDate()).local().format('MM/DD/YYYY HH:mm:ss')  }</td>
	                              								</tr>
	                              								<tr>
	                              									<td className="text-muted">Uploaded By:</td>
	                              									<td> {prop.user ? prop.user.name : prop.music_director.name}</td>
	                              								</tr>
	                              							</tbody>
	                              						</table>
	                              					</div>
	                              					
	                              					<div>
	                          							<div id="MDMedia">
	                          								{
	                          									prop.media_type === 'audio'
	                          									? 
	                          										<div className="audio_comment">
	                          											<div className="play" durationtest={durationAudio[key]} position={pos[key]}>
											                                {
											                                  !playing[key] &&
											                                  <button onClick={()=>this.handleTogglePlay(key)} test={prop.comment_url}><img src={play} alt="playImage" /></button>
											                                }
											                                {
											                                  playing[key] &&
											                                  <button onClick={()=>this.handleTogglePlay(key)} test={prop.comment_url}><img src={pause} alt="pauseImage" /></button>
											                                }
											                            </div>

											                            <div className="audio_player">
											                              <div className="dated">{   moment( moment.utc(prop.created_at).toDate()).local().format('MM/DD/YYYY HH:mm:ss')   } </div>
											                              {
											                                  prop.media_path &&
											                                 <Wavesurfer
											                                  audioFile={prop.media_path+'?'+HF.returnTimeStamp(prop.updated_at)}
											                                  pos={pos[key]}
											                                  onPosChange={(e)=>this.handlePosChange(e, key)}
											                                  playing={playing[key]?true:false}
											                                  crossorigin="anonymous"
											                                  onFinish={(e)=>this.handleFinish(e, key)}
											                                  onReady={(e)=>this.handleLoadingAudio(e,key)}
											                                  options= {{height: 65,waveColor: '#e1f0f0',progressColor: '#bcd7e0',cursorColor: '#a3c6cf', width:'100%'}}
											                                />
											                              }
											                              <div className="timer_en" test={durationAudio[key]}>{ moment.duration(durationAudio[key], "seconds").format() }</div>
											                              {
											                                pos[key] >= 1 &&
											                                <div className="timer_st">{ moment.duration(pos[key], "seconds").format() }</div>  
											                              }
											                              {
											                                pos[key] < 1 &&
											                                <div className="timer_st">0:00</div>
											                              }
											                            </div>
	                          										</div>
	                          									:
	                          										<div className="audio_comment">
	                          											{
	                          												prop.media_type === 'video'
	                          												?
	                          													<ReactPlayer className='react-player' url={prop.media_path+'?'+HF.returnTimeStamp(prop.updated_at)} controls={true} />		
	                          												:
			                              										<FileViewer
																			        fileType={prop.media_ext}
																			        filePath={prop.media_path+'?'+HF.returnTimeStamp(prop.updated_at)}
																			        errorComponent={CustomErrorComponent}
																			        onError={this.onError}
																		        	height={20}
																		        	width={20}
																		        />
	                          											}
															        </div>
	                          								}
		                              						
	                          							</div>
	                              					</div>

	                              					<div className="listControls flexElem justifyCenter alignCenter">
														{
															!this.props.mdId ? 
															<OverlayTrigger placement='left' overlay={<Tooltip id="tooltip">Delete Media</Tooltip>}>
																<button type='button' className="action-button-size" onClick={() => this.deleteConfirmMedia(prop.id)}><i className="fa fa-trash " /></button>
															</OverlayTrigger>
															:
															null
														}

								                      	<OverlayTrigger placement='left' overlay={<Tooltip id="tooltip">Download Media</Tooltip>}>
								                      	<button className="download_btn" onClick={()=>this.downloadFile(prop.media_path, prop.associate_by.concat('_', prop.id,'_', key+1))}>download</button>
								                      	</OverlayTrigger>
	                              					</div>
	                              				</div>
											);
										})
									}

	                          	</div>
	                          	{/*Add Destination Modal Start*/}
			                    	<ThemeModal modalClass="" size="lg" title='Upload Media' show={this.state.createMDMediaModal} hide={()=>{this.toggleModal('createMDMediaModal')}} >
				                        <MDMediaForm 
				                          formTypePro="add" 
				                          closeModel={HF.closeModal.bind(this, "createMDMediaModal")}
				                          mdId={mdId}
				                        />
			                      	</ThemeModal>
			                    {/*Add Destination Modal End*/}
		                 	</div>     
		            	</Col>
		         	</Row>
		       	</Grid>
			</div>
		);
	}
}

const mapDispatchToProps = dispatch => {
	return ({
		getMDMediaCall: (MDId) => { dispatch(festivalActions.getMDMedia(MDId)) },
		deleteMDMediaCall: (MediaId) => { dispatch(festivalActions.deleteMDMedia(MediaId)) },
	});
};

function mapStateToProps(state) {
	const { MDMediaList, storeMDMedia, deleteMDMedia, MDFestival } = state.festivalReducer;
	return {
		MDMediaList, storeMDMedia, deleteMDMedia, MDFestival
	};
}


const MDMediaList = connect(mapStateToProps, mapDispatchToProps)(MDMediaListPage);
export default MDMediaList;


// WEBPACK FOOTER //
// ./src/components/Admin/FestivalMusicDirector/MDMediaList.jsx